import {
  GridFilterModel,
  GridLogicOperator,
  GridPaginationModel,
  GridSortModel,
} from '@mui/x-data-grid-pro';

export const serializeSortModel = (sortModel: GridSortModel | undefined) => {
  return sortModel?.length
    ? sortModel.map((sort) => `${sort.field}:${sort.sort || 'desc'}`).join(',')
    : undefined;
};

export const deserializeSortModel = (searchParams: URLSearchParams): GridSortModel | undefined => {
  const sortCriteria = searchParams.get('sort') || '';
  return sortCriteria
    ? sortCriteria.split(',').map((sort) => {
        const [field, sortDirection] = sort.split(':');
        return { field, sort: sortDirection as 'asc' | 'desc' };
      })
    : undefined;
};

export const serializeFilterModel = (filterModel: GridFilterModel | undefined) => {
  if (!filterModel) return undefined;

  const { items, logicOperator, quickFilterValues, quickFilterLogicOperator } = filterModel;
  const filter =
    items
      .filter((filter) => filter.field && filter.operator && filter.value) // filter out incomplete filters
      .map((filter) => `${filter.field}:${filter.operator}(${filter.value})`) // serialize filters
      .join(',') || ''; // join filters with comma
  const quickFilter = quickFilterValues?.join(' ') || '';

  return filter || quickFilter
    ? {
        filter,
        quickFilter,
        logicOperator,
        quickFilterLogicOperator,
      }
    : undefined;
};

export const deserializeFilterModel = (
  searchParams: URLSearchParams
): GridFilterModel | undefined => {
  const filterCriteria = searchParams.get('filter') || '';
  const logicOperator = searchParams.get('logicOperator') || GridLogicOperator.And;
  const quickFilterValues = searchParams.get('quickFilterValues')?.split(' ') || [];
  const quickFilterLogicOperator =
    searchParams.get('quickFilterLogicOperator') || GridLogicOperator.And;

  return filterCriteria
    ? {
        items: filterCriteria
          ? filterCriteria.split(',').map((filter) => {
              const [field, operatorAndValue] = filter.split(':');
              const [operator, value] = operatorAndValue.split('(');
              return { field, operator, value: value.slice(0, -1) };
            })
          : [],
        logicOperator: logicOperator as GridLogicOperator,
        quickFilterValues,
        quickFilterLogicOperator: quickFilterLogicOperator as GridLogicOperator,
      }
    : undefined;
};

export const serializePagination = (paginationModel: GridPaginationModel | undefined) => {
  return paginationModel;
};

export const deserializePagination = (
  searchParams: URLSearchParams,
  initialPageSize?: number
): GridPaginationModel => {
  const page = parseInt(searchParams.get('page') || '1', 10) - 1;
  const pageSize = parseInt(
    searchParams.get('pageSize') || initialPageSize?.toString() || '10',
    10
  );
  return { page, pageSize };
};
